<template>
  <div class="express-inquiry">
    <div class="form-container">
      <el-form ref="form" :model="form" label-width="80px">
        <div class="flex">
          <el-form-item label="仓库：" prop="warehouseId">
            <el-select class="gray" clearable v-model="form.warehouseId" placeholder="请选择仓库">
              <el-option
                v-for="item in warehouse"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="16px">
            <el-button class="btn-blue" @click="inquiry()">搜索</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-button class="btn-blue" @click="toAddExpress()">新增规则</el-button>
    </div>
    <div class="table-container">
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="typeName" label="快递名称"></el-table-column>
          <el-table-column prop="warehouseName" label="仓库"></el-table-column>
          <el-table-column prop="customerName" label="适用范围"></el-table-column>
          <el-table-column prop="expressMethodName" label="计费类型"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.expressMethod === 2"
                :class="
                  scope.row.expressMethod === 2
                    ? 'btn-text btn-dis'
                    : 'btn-text'
                "
                @click="toExpressDetail(scope.row)"
                type="text"
              >详情</el-button>
              <el-button
                :disabled="scope.row.expressMethod === 2"
                :class="
                  scope.row.expressMethod === 2
                    ? 'btn-text btn-dis'
                    : 'btn-text'
                "
                @click="toModExpress(scope.row)"
                type="text"
              >编辑</el-button>
              <el-button class="btn-text" type="text" @click="delExpress(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增客户规制 -->
    <el-dialog title="新增规制" top="35vh" :visible.sync="addLogisticsRuleDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="logisticsForm"
        :rules="logisticsFormRules"
        :model="logisticsForm"
        label-width="80px"
      >
        <el-form-item label="仓库：" prop="warehouseId">
            <el-select
              class="gray"
              v-model="logisticsForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouse"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="快递名称：" prop="logisticsType">
          <el-select
            v-model="logisticsForm.logisticsType"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="expressMethod">
          <el-select
            v-model="logisticsForm.expressMethod"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in expressList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit('logisticsForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ExpressInquiry from "models/express-inquiry";
import Expenses from "models/expenses";
const expenses = new Expenses();
const expressInquiry = new ExpressInquiry();
import Logistics from "models/logistics";
const logistics = new Logistics();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      form: {
        warehouseId: ""
      },
      warehouse: [],
      tableData: [],
      logisticsForm: {
        warehouseId: "",
        logisticsType: "",
        expressMethod: "",
      },
      logisticsFormRules: {
        warehouseId: {
          required: true,
          message: "请选择仓库",
          trigger: "change",
        },
        logisticsType: {
          required: true,
          message: "请选择快递",
          trigger: "change",
        },
        expressMethod: {
          required: true,
          message: "请选择计费类型",
          trigger: "change",
        },
      },
      expressList: [
        {
          id: 1,
          name: "计重",
        },
        {
          id: 2,
          name: "现场定价",
        },
        {
          id: 3,
          name: "计体积",
        },
      ],
      expressObj: {
        1: '计重',
        2: '现场定价',
        3: '计体积'
      },
      logisticsList: [],
      addLogisticsRuleDialog: false
    };
  },
  created() {
    modifyNetTitle('承运商快递规则列表')
    this.getWarehouse();
    this.inquiry();
    this.getLogisticsList()
  },
  methods: {
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    //获取快递类型
    getLogisticsList() {
      logistics.getExpressData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
          if (this.$route.query.warehouseId) {
            this.form.logisticsType = Number(this.$route.query.expressType);
          }
        }
      });
    },
    //获取列表数据
    inquiry() {
      let warehouseId = this.form.warehouseId;
      expressInquiry.getExpressRuleList(warehouseId).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.typeName = value.typeName;
            obj.warehouseId = value.warehouseId;
            obj.warehouseName = value.warehouseName;
            obj.expressType = value.expressType;
            obj.customerId = value.customerId;
            obj.customerName = value.customerName;
            obj.expressMethodName = this.expressObj[value.expressMethod]
            obj.expressMethod = value.expressMethod;
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //删除数据
    delExpress(id) {
      this.$confirm("是否确定删除该承运商快递规则?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = { id };
        expressInquiry.postDelExpress(data).then(res => {
          if (res.success) {
            this.inquiry();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    toExpressDetail(row) {
      let warehouseId = row.warehouseId;
      let warehouseName = row.warehouseName;
      let typeName = row.typeName;
      let expressType = row.expressType;
      let customerId = row.customerId;
      let expressMethod = row.expressMethod;
      this.$router.push(
        `/base-info/carrier/express/express-detail?warehouseId=${warehouseId}&warehouseName=${warehouseName}&typeName=${typeName}&expressType=${expressType}&customerId=${customerId}&expressMethod=${expressMethod}`
      );
    },
    toModExpress(row) {
      if (row) {
        let warehouseId = row.warehouseId;
        let expressType = row.expressType;
        let customerId = row.customerId;
        let expressMethod = row.expressMethod;
        this.$router.push({
          path: "/base-info/carrier/express/add-express",
          query: {
            warehouseId,
            expressType,
            customerId,
            expressMethod,
            isUpdate: 1
          }
        });
      }
    },
    toAddExpress() {
      this.addLogisticsRuleDialog = true
    },
    closeDialog() {
      this.$refs["logisticsForm"].resetFields();
      this.addLogisticsRuleDialog = false
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let warehouseId = this.logisticsForm.warehouseId
          let expressType = this.logisticsForm.logisticsType
          let expressMethod = this.logisticsForm.expressMethod
          let data = {
            warehouseId,
            expressType,
            expressMethod
          }
          expenses.postAddBaseInfo(data).then(res => {
            if (res.success) {
              if (expressMethod != 2) {
                this.$router.push({
                  path: "/base-info/carrier/express/add-express",
                  query: {
                    warehouseId,
                    expressType,
                    expressMethod,
                    isUpdate: 0
                  }
                });
              } else {
                this.closeDialog()
                this.inquiry();
              }
            } else {
              this.$message.error(res.message)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.express-inquiry {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    padding-bottom: 0;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    .el-form {
      .flex {
        display: flex;
      }
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .table {
      display: flex;
      .btn-dis {
        color: #c0c4cc;
      }
    }
  }
  .el-dialog {
    .el-form {
      .el-form-item__content {
        height: 32px;
        display: flex;
        align-items: center;
        .el-select {
          width: 100%;
        }
      }
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
